import { versionedHttpCollection } from "us.helper/http/collection";
import ServiceConfig from "service.config.js";

export default {
  assignedDocuments: {
    get: <P extends {}>(params: P): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "documentservice",
            "mappedDocumentList",
            params,
            ServiceConfig()[`documentservice`]["document"],
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },

    delete: <P extends {}>(params: P): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.patch(
            "documentservice",
            "mappedDocumentList",
            params,
            ServiceConfig()[`documentservice`]["document"],
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  documentContent: {
    get: <P extends { lookupId: number; system: string; lookupType: string }>(
      params: P,
    ): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data ,status } = await versionedHttpCollection.get(
            "documentservice",
            "document",
            params,
            ServiceConfig()[`documentservice`]["document"],
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
